import { selectIsLoading, selectIsLoggedIn } from '../Login/loginSlice'
import NotificationSummary from 'containers/Chats/NotificationSummary'
import { ACCOUNT_TYPE } from 'containers/Account/accountSlice'
import { useHistory, useParams } from 'react-router-dom'
import { LOCATION_STATES } from '../../utils/constants'
import useTranslation from 'hooks/useTranslation'
import { useSelector } from 'react-redux'
import Popups, { POPUPS } from './Popups'
import Shortcuts from './Shortcuts'
import { useEffect } from 'react'
import Favorite from './Favorite'
import './style.scss'

const Dashboard = () => {
  const isLoading = useSelector(selectIsLoading)
  const isLogin = useSelector(selectIsLoggedIn)

  const { key } = useParams()
  const { push } = useHistory()
  const { replace } = useHistory()
  const { t } = useTranslation('dashboard')
  const showPopup = p => {
    push(window.location.pathname, LOCATION_STATES.popup(p))
  }

  useEffect(() => {
    if (!isLogin && !isLoading && key !== ACCOUNT_TYPE.settings) replace('/login')
  }, [isLoading, isLogin, key, replace])

  return (
    <div className='dashboard'>
      <Popups />
      <div className='dashboard__title'>
        <h2>{t('messages')}</h2>
        <div
          onClick={() => {
            push('/chat')
          }}>
          <span>{t('goTo')}</span>
          <i className='icon icon--arrow-right'></i>
        </div>
      </div>
      <NotificationSummary />

      <div className='dashboard__title'>
        <h2>{t('favorites')}</h2>
        <div
          onClick={() => {
            showPopup({ type: POPUPS.editFavorite })
          }}>
          <span>{t('edit')}</span>
          <i className='icon icon--arrow-right'></i>
        </div>
      </div>
      <Favorite />

      <div className='dashboard__title'>
        <h2>{t('shortcuts')}</h2>
        <div
          onClick={() => {
            showPopup({ type: POPUPS.editShortcuts })
          }}>
          <span>{t('edit')}</span>
          <i className='icon icon--arrow-right'></i>
        </div>
      </div>
      <Shortcuts />

    </div>
  )
}

export default Dashboard